module.exports = __webpack_public_path__ + "img/search-by-zip-chevy.60e8ac42.png";